import React, { useContext } from "react";
import { CardBody, Col, Row, TabContent, TabPane } from "reactstrap";
import OfferNav from "./OfferNav";
import OfferDetails from "./OfferDetails";
import ServiceForOffer from "./ServiceForOffer";
import { EffectiveAt } from "./EffectiveAt";
import Grants from "./Grants";
import Charges from "./Charges";
import Usage from "./Usage";
import { CreateOfferContext } from "./context";

const AddOfferContent = () => {
  const { activeMainTab, isEdit, rightContentRef } =
    useContext(CreateOfferContext);
  return (
    <Row className="mt-4 mx-1">
      <Col lg={2}>
        <OfferNav />
      </Col>
      <Col lg={10}>
        <div className="offer-tab-right" ref={rightContentRef}>
          <TabContent activeTab={activeMainTab}>
            <TabPane tabId={1}>
              <div className="border p-3">
                <OfferDetails />
                <Row>
                  <Col xxl={12} md={12}>
                    <ServiceForOffer />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col xxl={12} md={12}>
                    {isEdit && <EffectiveAt />}
                  </Col>
                </Row>
              </div>
            </TabPane>
            <TabPane tabId={2}>
              <Grants />
            </TabPane>
            <TabPane tabId={3}>
              <Charges />
            </TabPane>
            <TabPane tabId={4}>
              <Usage />
            </TabPane>
          </TabContent>
        </div>
      </Col>
    </Row>
  );
};

export default AddOfferContent;
